import React from 'react';

import { deepFindProperty } from 'components/PlateEditor/utils/deepFindProperty';

export const ListItemElement = (props) => {
  const { element, children, style: styleProp = {} } = props;

  const fontSize = deepFindProperty('fontSize', element);
  const fontFamily = deepFindProperty('fontFamily', element);
  const color = deepFindProperty('color', element);

  let style = styleProp;

  if (fontSize) {
    // fontSize will be in '13px' format, so we split it to get the value in int format.
    // #TODO: remove magic numbers and add a global slate setting for default values (font size).
    const fontSizeArr = fontSize ? fontSize.split('px') : [13];
    const fontSizeValue = parseInt(fontSizeArr[0], 10);
    style = {
      ...style,
      fontSize,
      // Current left padding of lists is 15px so we subtract that from font size to get approx spacing.
      marginLeft: fontSizeValue > 13 ? `${fontSizeValue - 15}px` : null,
    };
  }

  if (fontFamily) {
    style = {
      ...style,
      fontFamily,
    };
  }

  if (color) {
    style = {
      ...style,
      color,
    };
  }

  return (
    <li
      style={style}
    >
      {children}
    </li>
  );
};
